import type { dealerSearchIncoming } from "./dealerSearchIncoming";
import type { dealerSearchOutgoing } from "./dealerSearchOutgoing";

export interface dealerSearchIncomingExtended extends dealerSearchIncoming {
  outputSpec: outputSpec[];
}
export type outputSpec =
  | "id"
  | "type"
  | "status"
  | "verticalType"
  | "name"
  | "url"
  | "internalUrl"
  | "properties.Inventory.Automotive.Classifieds.priceIncrement"
  | "properties.inventoryrule.olderThanYear"
  | "properties.Inventory.Automotive.Wholesale.yearFuzz"
  | "properties.Inventory.Automotive.Fleet.startMileage"
  | "properties.Inventory.Automotive.Fleet.mileageIncrement"
  | "properties.Inventory.Automotive.Classifieds.startMileage"
  | "properties.Inbox.NotificationRule.hideBouncedEmail"
  | "properties.Inventory.Automotive.Primary.Used.defaultPriceField"
  | "properties.Inventory.Automotive.Wholesale.useDefaultColors"
  | "properties.Inventory.Automotive.Fleet.epricerField"
  | "properties.Inventory.Automotive.Fleet.endMileage"
  | "properties.LeadMachine.numberOfUsers"
  | "properties.Inbox.NotificationRule.noTradeInLeads"
  | "properties.Inventory.Automotive.Wholesale.useDefaultOptions"
  | "properties.Inbox.NotificationRule.noVehicleLeads"
  | "properties.Inventory.Automotive.Classifieds.startYear"
  | "properties.inventoryrule.daysInventoryUsedFeatured"
  | "properties.Inventory.Automotive.Classifieds.endMileage"
  | "properties.Inventory.Automotive.Primary.priceFuzz"
  | "properties.Inventory.Automotive.Fleet.Used.defaultPriceField"
  | "properties.timeZone"
  | "properties.Inventory.Automotive.Exotic.startPrice"
  | "properties.Inventory.Automotive.Primary.useDefaultOptions"
  | "properties.Inventory.Automotive.Classifieds.epricerField"
  | "properties.Inventory.Automotive.Exotic.endMileage"
  | "properties.Inbox.reaperDays"
  | "properties.Inbox.NotificationRule.hideIncomingEmailAssignedToOthers"
  | "properties.Inventory.Automotive.Classifieds.startPrice"
  | "properties.Inbox.NotificationRule.noGenericLeads"
  | "properties.Inventory.Automotive.Exotic.useDefaultColors"
  | "latitude"
  | "Inventory.Automotive.Primary.mileageFuzz"
  | "Inbox.NotificationRule.noFinanceForms"
  | "Inventory.Automotive.Wholesale.mileageFuzz"
  | "Inventory.Automotive.Classifieds.New.defaultPriceField"
  | "Inventory.Automotive.Exotic.useDefaultBodyStyles"
  | "shouldAuditContract"
  | "Inventory.Automotive.Classifieds.yearIncrement"
  | "Inventory.Automotive.Primary.New.defaultPriceField"
  | "Inventory.Automotive.Fleet.yearIncrement"
  | "Inventory.Automotive.Fleet.priceFuzz"
  | "Inventory.Automotive.Wholesale.startYear"
  | "Inventory.Automotive.Classifieds.priceFuzz"
  | "Inventory.Automotive.Fleet.startPrice"
  | "Bounce.fromAddress"
  | "Inventory.Automotive.Wholesale.startPrice"
  | "Inventory.Automotive.Exotic.startMileage"
  | "Inventory.Automotive.Fleet.endYear"
  | "Inventory.Automotive.Fleet.useDefaultOptions"
  | "Inventory.Automotive.Primary.useDefaultMakesModels"
  | "showRandomVideoPercentage"
  | "Inbox.NotificationRule.hideNotesCreatedByMe"
  | "Inventory.Automotive.Primary.startYear"
  | "Inventory.Automotive.Wholesale.endMileage"
  | "Inventory.Automotive.Classifieds.useDefaultColors"
  | "Inventory.Automotive.Classifieds.useDefaultMakesModels"
  | "Inventory.Automotive.Primary.epricerField"
  | "Inventory.Automotive.Wholesale.priceFuzz"
  | "Inventory.Automotive.Exotic.New.defaultPriceField"
  | "Inventory.Automotive.Wholesale.epricerField"
  | "Inventory.Automotive.Classifieds.Used.defaultPriceField"
  | "Inventory.Automotive.Primary.startMileage"
  | "inventoryrule.showRandomMaxFeatured"
  | "Inventory.Automotive.Fleet.startYear"
  | "Inventory.Automotive.Primary.endPrice"
  | "Inventory.Automotive.Exotic.useDefaultOptions"
  | "Inventory.Automotive.Primary.useDefaultBodyStyles"
  | "Inventory.Automotive.Primary.startPrice"
  | "Quotefactory.earliestYear"
  | "inventoryrule.oldestUsedFeatured"
  | "Inventory.Automotive.Primary.endMileage"
  | "LeadMachine.areSeatsShared"
  | "Inventory.Automotive.Exotic.epricerField"
  | "Inventory.Automotive.Primary.useDefaultColors"
  | "Inventory.Automotive.Fleet.useDefaultColors"
  | "inventoryrule.maxInternetPriceFeatured"
  | "longitude"
  | "Inventory.Automotive.Fleet.endPrice"
  | "Inbox.NotificationRule.noPartsLeads"
  | "clientReportDate"
  | "Inventory.Automotive.Primary.endYear"
  | "Inbox.NotificationRule.hideOutgoingEmailAssignedToOthers"
  | "Inventory.Automotive.Exotic.mileageFuzz"
  | "Inventory.Automotive.Wholesale.startMileage"
  | "Inventory.Automotive.Wholesale.mileageIncrement"
  | "Inventory.Automotive.Wholesale.New.defaultPriceField"
  | "Inventory.Automotive.Fleet.priceIncrement"
  | "Inbox.NotificationRule.noServiceLeads"
  | "Inventory.Automotive.Exotic.startYear"
  | "inventoryrule.daysInventoryNewFeatured"
  | "Inventory.Automotive.Wholesale.yearIncrement"
  | "Inventory.Automotive.Classifieds.endPrice"
  | "Inventory.Automotive.Wholesale.priceIncrement"
  | "Inventory.Automotive.Classifieds.useDefaultBodyStyles"
  | "Inventory.Automotive.Fleet.mileageFuzz"
  | "Inventory.Automotive.Exotic.mileageIncrement"
  | "Inventory.Automotive.Primary.yearFuzz"
  | "Inventory.Automotive.Classifieds.mileageIncrement"
  | "Inventory.Automotive.Exotic.yearIncrement"
  | "Inventory.Automotive.Exotic.endYear"
  | "Inventory.Automotive.Exotic.yearFuzz"
  | "Inventory.Automotive.Wholesale.endYear"
  | "Inventory.Automotive.Wholesale.Used.defaultPriceField"
  | "Inventory.Automotive.Exotic.Used.defaultPriceField"
  | "Inventory.Automotive.Wholesale.endPrice"
  | "Inventory.Automotive.Classifieds.endYear"
  | "Inventory.Automotive.Fleet.New.defaultPriceField"
  | "Inventory.Automotive.Exotic.priceIncrement"
  | "Inventory.Automotive.Primary.yearIncrement"
  | "Inventory.Automotive.Fleet.useDefaultBodyStyles"
  | "Inventory.Automotive.Fleet.yearFuzz"
  | "Inventory.Automotive.Exotic.priceFuzz"
  | "Inventory.Automotive.Exotic.endPrice"
  | "Inventory.Automotive.Wholesale.useDefaultMakesModels"
  | "Inventory.Automotive.Primary.priceIncrement"
  | "Inbox.NotificationRule.noOrders"
  | "Inbox.NotificationRule.hideNotesAssignedToOthers"
  | "Inventory.Automotive.Fleet.useDefaultMakesModels"
  | "Inbox.NotificationRule.noPhoneLeads"
  | "LeadMachine.externalEmailCommunication"
  | "Inventory.Automotive.Classifieds.yearFuzz"
  | "Inventory.Automotive.Wholesale.useDefaultBodyStyles"
  | "Inventory.Automotive.Classifieds.mileageFuzz"
  | "Voicestar.numberOfCampaigns"
  | "address.address1"
  | "address.address2"
  | "address.city"
  | "address.state"
  | "address.postalCode"
  | "address.country"
  | "primaryContactInformation.phoneNumbers.type"
  | "primaryContactInformation.phoneNumbers.number"
  | "primaryContactInformation.email"
  | "primaryContactInformation.firstName"
  | "primaryContactInformation.lastName"
  | "hours"
  | "localizedHours"
  | "ancestorAccountIds"
  | "descendantAccountIds"
  | "childAccountIds"
  | "parentAccountIds"
  | "franchiseList"
  | "dealerCodes"
  | "grantedResources"
  | "departments"
  | "controlCenterPlatform"
  | "created";

export type countries = "US" | "USA" | "CA";
export type statuses = "ACTIVE" | "IN_PRODUCTION" | "INACTIVE" | "SUSPENDED";
export type accountTypes = "CLIENT" | "DEMO" | "TEST" | "VENDOR";
export type verticalTypes =
  | "DDC"
  | "AUTOMOTIVE_PORTAL"
  | "AUTOMOTIVE_DEALERSHIP_GROUP"
  | "AUTOMOTIVE_FRANCHISE_DEALERSHIP"
  | "AUTOMOTIVE_INDEPENDENT_DEALERSHIP"
  | "ASSOCIATION"
  | "OTHER"
  | "RESELLER";
export const verticalTypeMapping: { value: verticalTypes; label: string }[] = [
  { value: "AUTOMOTIVE_DEALERSHIP_GROUP", label: "Dealership Group" },
  { value: "AUTOMOTIVE_FRANCHISE_DEALERSHIP", label: "Franchise Dealership" },
  {
    value: "AUTOMOTIVE_INDEPENDENT_DEALERSHIP",
    label: "Independent Dealership"
  },
  { value: "AUTOMOTIVE_PORTAL", label: "Portal" },
  { value: "DDC", label: "DDC" },
  { value: "ASSOCIATION", label: "Association" },
  { value: "OTHER", label: "Other" },
  { value: "RESELLER", label: "Reseller" }
];
export type controlCenterPlatform = "SEVEN" | "SIX";
export interface complexMatchSpec<TSearchableItem> {
  matchAny?: TSearchableItem[];
  matchAll?: TSearchableItem[];
  matchNone?: TSearchableItem[];
}
export interface dealerCodeSpecComplexMatchSpec {
  matchAll?: dealerCodes[];
}
export interface dealerCodes {
  type: string;
  codes: string[];
}

export interface dealerCode {
  type: string;
  code: string;
}

export type states = usStates | caStates | "";

export type caStates =
  | "AB"
  | "BC"
  | "MB"
  | "NB"
  | "NL"
  | "NS"
  | "NT"
  | "NU"
  | "ON"
  | "PE"
  | "QC"
  | "SK"
  | "YT";

export type usStates =
  | "AL"
  | "AK"
  | "AZ"
  | "AR"
  | "CA"
  | "CO"
  | "CT"
  | "DE"
  | "DC"
  | "FL"
  | "GA"
  | "HI"
  | "ID"
  | "IL"
  | "IN"
  | "IA"
  | "KS"
  | "KY"
  | "LA"
  | "ME"
  | "MD"
  | "MA"
  | "MI"
  | "MN"
  | "MS"
  | "MO"
  | "MT"
  | "NE"
  | "NV"
  | "NH"
  | "NJ"
  | "NM"
  | "NY"
  | "NC"
  | "ND"
  | "OH"
  | "OK"
  | "OR"
  | "PA"
  | "RI"
  | "SC"
  | "SD"
  | "TN"
  | "TX"
  | "UT"
  | "VT"
  | "VA"
  | "WA"
  | "WV"
  | "WI"
  | "WY"
  | "GU"
  | "MP"
  | "PR";

export interface dealerSearchOutgoingInternalError {
  timestamp: string;
  status: number;
  error: string;
  message: string;
  path: string;
}

export interface dealerSearchOutgoingInternalHitsDownload {
  id: string;
  name: string;
  url: string;
  status: statuses;
  verticalType: verticalTypes;
  franchiseList: string[];
  dealerCodes: dealerCode[];
  address: {
    city: string;
    state: usStates | caStates;
  };
}

export const isDealerSearchOutgoingInternalHits = (
  data?:
    | dealerSearchOutgoingInternalHits
    | dealerSearchOutgoingInternalHitsDownload
): data is dealerSearchOutgoingInternalHits => {
  if (!data) return false;
  return (data as dealerSearchOutgoingInternalHits).created !== undefined;
};
export interface dealerSearchOutgoingInternalHits {
  id: string;
  name: string;
  url: string | null;
  status: statuses;
  created: string;
  type: accountTypes;
  verticalType: verticalTypes;
  franchiseList: string[];
  grantedResources: string[];
  dealerCodes: dealerCode[];
  address: {
    address1?: string | null;
    postalCode?: string | null;
    city: string | null;
    country: countries | null | "";
    state: usStates | caStates | null | "";
  };
}
export interface dealerSearchOutgoingInternalDownload {
  from: number;
  size: number;
  totalHits: number;
  hits: dealerSearchOutgoingInternalHitsDownload[];
}

export interface dealerSearchOutgoingInternal {
  from: number;
  size: number;
  totalHits: number;
  hits: dealerSearchOutgoingInternalHits[];
}

export const isDealerSearchOutgoingInternalError = (
  data?: unknown
): data is dealerSearchOutgoingInternalError => {
  if (!data) return false;
  return (data as dealerSearchOutgoingInternalError).error !== undefined;
};

export interface useAccountSearchResult {
  accountSearchResult: dealerSearchOutgoing | null;
  accountSearchLoading: boolean;
  isSearchDefault: boolean;
  accountSearchError: string | null;
  searchRequest: dealerSearchIncoming;
  setSearchRequest: (searchRequest?: dealerSearchIncoming) => void;
  setPage: (page: number) => void;
  setSize: (size: number) => void;
  page: number;
  size: number;
}

export interface dealerFiltersResult {
  franchises: string[];
  resources: string[];
  dealerCodeTypes: string[];
}

export const dealerFiltersResultExample: dealerFiltersResult = {
  resources: [
    "AT.KBB.Reporting",
    "Accessories",
    "AccountInfo",
    "Advertising.Analytics.Reporting",
    "Advertising.Compass",
    "Advertising.Display.AdBuilder",
    "Advertising.Display.InvoicedBilling",
    "Advertising.Display.ManagedProgramAccess",
    "Advertising.Feature.Audience.KBB",
    "Advertising.Feature.AutomatedVideo",
    "Advertising.Feature.Display",
    "Advertising.Feature.Integrations.VAuto",
    "Advertising.Feature.Search",
    "Advertising.Feature.Social.DPA",
    "Advertising.Feature.Social.Image",
    "Advertising.Feature.Social.Leads",
    "Advertising.Feature.Video.Display",
    "Advertising.Feature.Video.Facebook",
    "Advertising.Feature.Video.YouTube",
    "Advertising.Fluency.FordDirect.MarchexCallTracking",
    "Advertising.GroupAdvertisingDashboard",
    "Advertising.ManagementTool.Fluency",
    "Advertising.Provider.CoxMediaAAM",
    "Advertising.Social.Access",
    "Advertising.Social.Edit",
    "Advertising.UAD.Dashboard",
    "Advertising.UAD.GroupAsSinglePoint",
    "Advertising.UAD.ManageInvestment",
    "Advertising.UnifiedAdvertisingDashboard",
    "Analytics.Beta",
    "Analytics.DigitalRetailingDRS",
    "Analytics.Dw2AdvertisingReporting",
    "Analytics.Dw2Reporting",
    "Analytics.IntegratedDigitalRetailingReports",
    "Analytics.Management",
    "Analytics.SalesAttributionReporting",
    "AudiVQMSOnlinePurchaseFlag",
    "BatchImageUpload",
    "BounceManager",
    "BulkUploaderApplet",
    "CA.SearchByPayment",
    "CC.Promo1",
    "CC.Promo2",
    "CC.Promo3",
    "CC.Promo4",
    "CC.Promo5",
    "CC7.CoCo.Header",
    "CC7.CoCo.Header.AccountSwitcher",
    "CC7.CoCo.Header.ApplicationDebugInfo",
    "CC7.CoCo.Header.ApplicationNavigation",
    "CC7.CoCo.Header.ApplicationSwitcher",
    "CC7.CoCo.Header.Help",
    "CC7.CoCo.Header.Links",
    "CC7.CoCo.Header.LogOut",
    "CC7.CoCo.Header.Logo",
    "CC7.CoCo.Header.Notifications",
    "CC7.CoCo.Header.UserDealerName",
    "CCLite.Trader",
    "CLLCChromePartsAndAccessories",
    "CRM",
    "CRM.Admin",
    "CRM.Billing",
    "CRM.Bootstrap",
    "CRM.DealerTrack",
    "CRM.Lite",
    "Calendar",
    "CallListening",
    "CallSource",
    "CallTracking",
    "CallTracking.NoCallRecording",
    "CampaignTracking",
    "CarFax",
    "CarProof",
    "ClassifiedsConfig",
    "ClassifiedsNewStockPhotos",
    "ClassifiedsNewVehicles",
    "ClassifiedsUsedStockPhotos",
    "ClassifiedsUsedVehicles",
    "ColorStockPhotos",
    "Configuration.Display.OverrideHours",
    "ConsumerPrivacyManager",
    "ContactAtOnce",
    "ContactImport",
    "Contacts",
    "Craigslist",
    "DMSIntegrationOnly",
    "DMiSalesData",
    "DR3.0SearchByPayment",
    "Data.Incentives",
    "Data.Incentives.CVI",
    "Data.Provider.AIS",
    "Data.Provider.AIS.CANADA",
    "Data.Provider.Acura",
    "Data.Provider.Autodata",
    "Data.Provider.BMW",
    "Data.Provider.CVI",
    "Data.Provider.Dealertrack.Canada",
    "Data.Provider.Edmunds",
    "Data.Provider.Evox",
    "Data.Provider.GM",
    "Data.Provider.GST",
    "Data.Provider.Honda",
    "Data.Provider.Jato",
    "Data.Provider.Kia",
    "Data.Provider.Lexus.SD",
    "Data.Provider.NewCarTestDrive",
    "Data.Provider.SOA",
    "Data.Provider.Toyota",
    "Data.Provider.Toyota.SD",
    "Data.Provider.Trader",
    "Data.Provider.Video.CarFlix2.French",
    "Data.Provider.Video.CarFlix2.New",
    "Data.Provider.Video.CarFlix2.New.Process",
    "Data.Provider.Video.CarFlix2.Spanish",
    "Data.Provider.Video.CarFlix2.Used",
    "Data.Provider.Video.CarFlix2.Used.Process",
    "Data.Provider.Video.CarFlixFX",
    "Data.Provider.Video.DealerSpecialties",
    "Data.Provider.Video.SisterTech.New",
    "Data.Provider.Video.SisterTech.New.Process",
    "Data.Provider.Video.SisterTech.Used",
    "Data.Provider.Video.SisterTech.Used.Process",
    "Data.Provider.Video.Unity",
    "Data.Provider.Video.Youtube.New",
    "Data.Provider.Video.Youtube.Used",
    "Data.VinExplosion",
    "DealerTrack",
    "DealerTrack.Classic",
    "DealerTrackCommonContainer",
    "DigitalRetailingDeals",
    "DigitalRetailingDeals.NoDeals",
    "DisplayAdvertising.BasicAccess",
    "DisplayAdvertising.BillingAuthorized",
    "DisplayAdvertising.ContentManagement",
    "DisplayAdvertising.GroupManagement",
    "ELendSolutions",
    "Ebay",
    "Ebay.Integration",
    "Email.Management",
    "Email.Management.Admin",
    "ExoticConfig",
    "ExoticNewStockPhotos",
    "ExoticNewVehicles",
    "ExoticUsedStockPhotos",
    "ExoticUsedVehicles",
    "Export.CarGurus",
    "Export.Edmunds",
    "Export.Google.Base",
    "Export.Yahoo",
    "FiftyBelow",
    "FinanceLeads",
    "FixedOpsReports",
    "FleetConfig",
    "FleetNewStockPhotos",
    "FleetNewVehicles",
    "FleetUsedStockPhotos",
    "FleetUsedVehicles",
    "FordDirectFriendsAndNeighbors",
    "GenericLeads",
    "HookLogic",
    "Incentives.FordTXConditional",
    "IncentivesManager",
    "IncentivesManager.ManualInsert",
    "IntegratedDigitalRetailingReports",
    "Inventory.Auction.OVE",
    "Inventory.Auction.Openlane",
    "Inventory.CourtesyVehicles",
    "Inventory.Dashboard80",
    "Inventory.EnableDIGImages",
    "Inventory.ForceAutoDataEquipment",
    "Inventory.ForceFDDealerServicesImages",
    "Inventory.HealthScorecards",
    "Inventory.HideCC6Edit",
    "Inventory.HighMsrpPricing",
    "Inventory.InventoryMappedIncentives",
    "Inventory.Manager",
    "Inventory.OptionsPackageBuilder",
    "Inventory.ProcessNextGenHLFeatures",
    "Inventory.SetCourtesyVehiclesNew",
    "Inventory.SetInServiceAsCourtesy",
    "InventoryExports",
    "InventoryLifecycles",
    "InventoryLifecycles.Advanced",
    "InventoryLifecycles.ImageOverlays",
    "InventoryLifecycles.ImageOverlays.TraderLite",
    "InventoryLifecycles.Incentives.EditVisibility",
    "InventoryLifecycles.MarketData",
    "InventoryLifecycles.TraderLite",
    "InventoryManager7",
    "InventoryManagerLegacy",
    "InventoryReports",
    "ItemFinder",
    "ItemLeads",
    "KBBTrustedAdvisorProgram",
    "LeadMachine",
    "LeadMachineAdmin",
    "LeadMachineLite",
    "LeadMachineReports",
    "LeadReports",
    "LeadViewer",
    "Managed.Social",
    "MarketPlace.Account.Settings",
    "MarketingDynamicSEOAdvanced",
    "MarketingTotalControlDominator",
    "MarketingTotalControlDominator.AdBuilder",
    "MarketingTotalControlDominator.DeepLinking",
    "MarketingTotalControlDominator.Microsite",
    "MarketingTotalControlDominator.PaperBilling",
    "MarketingTotalControlDominator.SelfManaged",
    "MediaLibrary",
    "MediaLibrary.Flash",
    "MediaLibrary.Video",
    "MobileAdvertising",
    "MobileAnalytics",
    "MobileCRM",
    "MobileLotCapture",
    "OfferLogix",
    "Orders",
    "PhoneLeads",
    "PhoneManager.Lockdown",
    "PhoneReports",
    "Powermail",
    "PrimaryAllRealestate_ca",
    "PrimaryConfig",
    "PrimaryNewAtv",
    "PrimaryNewBoat",
    "PrimaryNewFarmEquipment",
    "PrimaryNewHeavyEquipment",
    "PrimaryNewHeavyTruck",
    "PrimaryNewMotorcycle",
    "PrimaryNewPwc",
    "PrimaryNewRv",
    "PrimaryNewSnowmobile",
    "PrimaryNewStockPhotos",
    "PrimaryNewTrailer",
    "PrimaryNewVehicles",
    "PrimaryUsedAtv",
    "PrimaryUsedBoat",
    "PrimaryUsedFarmEquipment",
    "PrimaryUsedHeavyEquipment",
    "PrimaryUsedHeavyTruck",
    "PrimaryUsedMotorcycle",
    "PrimaryUsedPwc",
    "PrimaryUsedRv",
    "PrimaryUsedSnowmobile",
    "PrimaryUsedStockPhotos",
    "PrimaryUsedTrailer",
    "PrimaryUsedVehicles",
    "PriorityVehicles",
    "Products",
    "PromotionsManager",
    "PublishRulesFeedAttributes",
    "Quotefactory",
    "ReferralTracking",
    "Reports.Datasource.v2",
    "RouteOne",
    "RyantechSalesData",
    "Safenet",
    "SalesMatching",
    "SalesReports",
    "ServiceMenu",
    "ServiceTracker",
    "Shift.FloorUpIntegration",
    "SmartSites",
    "SmartSites.Blogging",
    "SmartSites.BubbleAds",
    "SmartSites.ClickForACall",
    "SmartSites.ClickMap.Collect",
    "SmartSites.ClickMap.Display",
    "SmartSites.Commenting.AutoComments.New",
    "SmartSites.Commenting.AutoComments.Used",
    "SmartSites.Commenting.Vehicles",
    "SmartSites.Commenting.Video",
    "SmartSites.CustomCss",
    "SmartSites.CustomEVoxPerspectives",
    "SmartSites.CustomEntryCoupons",
    "SmartSites.CustomExitCoupons",
    "SmartSites.CustomSitemap",
    "SmartSites.DealerChat",
    "SmartSites.DesignEditor",
    "SmartSites.DesignSelector",
    "SmartSites.DomainSSL",
    "SmartSites.EditMetaData",
    "SmartSites.EnhancedVehicleRecommendations",
    "SmartSites.EnhancedVehicleRecommendations.Autotrader",
    "SmartSites.EnhancedVehicleRecommendations.KBB",
    "SmartSites.Experiments",
    "SmartSites.FinanceApplication.DealerTrack",
    "SmartSites.FormBuilder",
    "SmartSites.HTMLSlideshow",
    "SmartSites.Incentives",
    "SmartSites.Incentives.QualifiedOffers",
    "SmartSites.InstantEprice",
    "SmartSites.JDPowerRatings",
    "SmartSites.JavascriptEnabler",
    "SmartSites.Jumpstart",
    "SmartSites.MobileSites",
    "SmartSites.MobileSites.v2",
    "SmartSites.ModelSpecificLandingPages",
    "SmartSites.MyCars",
    "SmartSites.MyCars.DealerAuthorized",
    "SmartSites.MyCars.v2",
    "SmartSites.PageBuilder",
    "SmartSites.PageBuilder.GroupDistribution",
    "SmartSites.PaymentCalculator.DealerTrack",
    "SmartSites.PhoneNumberTracking",
    "SmartSites.RememberMe",
    "SmartSites.SEOURLs",
    "SmartSites.Seamless.Beta",
    "SmartSites.SecureLogin",
    "SmartSites.SiteBuilder",
    "SmartSites.SlideshowDistribution",
    "SmartSites.SmartOffers",
    "SmartSites.SmartSpecials",
    "SmartSites.Social.Smartbar",
    "SmartSites.Specials.Accessory",
    "SmartSites.Specials.Ad",
    "SmartSites.Specials.Certified",
    "SmartSites.Specials.Finance",
    "SmartSites.Specials.Generic",
    "SmartSites.Specials.Incentive",
    "SmartSites.Specials.NewVehicle",
    "SmartSites.Specials.Parts",
    "SmartSites.Specials.Preowned",
    "SmartSites.Specials.Rebate",
    "SmartSites.Specials.Service",
    "SmartSites.Tier1BuildAndPrice",
    "SmartSites.TradeDriver.DealerTrack",
    "SmartSites.Translations.French",
    "SmartSites.Translations.Spanish",
    "SmartSites.Vehicle.OnDeposit",
    "SmartSites.VehicleDetails.JatoData",
    "SmartSites.VehicleDetails.eBrochure",
    "SmartSites.VehicleDetails.eVoxSpins",
    "SmartSites.VehicleDetails.eVoxStills",
    "SmartSites.Video.Blogging",
    "SmartSites.Video.Gallery",
    "SmartSites.Video.NPV",
    "SmartSites.Video.RealEstate",
    "SmartSites.Video.RealEstate.French",
    "SmartSites.Video.Slides",
    "SmartSites.VirtualShowroom",
    "SmartSites.WildcardSSL",
    "Social.Beta",
    "Social.Composer",
    "Social.DealerRatings",
    "Social.Facebook.Incentives",
    "Social.Facebook.Inventory",
    "Social.Facebook.Video",
    "Social.Group.Access",
    "Social.GroupDistribution",
    "Social.Loyalty.NewsDriver",
    "Social.Loyalty.ReviewDriver",
    "Social.Managed",
    "Social.Realtime.Feeds",
    "Social.RepDriver",
    "Social.RepDriver.SiteIntegration",
    "Social.ReputationMonitor",
    "Social.Syndicator",
    "Social.Syndictaion.Approver",
    "SoldInventory",
    "Special.Shift.Resource",
    "SpecialsBuilder",
    "SpecialsBuilder.Pro",
    "SpecialsBuilder.Two",
    "SpecialsLeads",
    "Store",
    "TradeMotion",
    "UpdateShotProfiles",
    "UpgradeCenter",
    "UpgradeCenter.Retail",
    "UrbanScience.FloorUpIntegration",
    "UserManager",
    "VAuto",
    "VehicleLeads",
    "VehiclePartsLeads",
    "VehicleServiceLeads",
    "VehicleTradeInLeads",
    "VideoConfig",
    "VideoExport",
    "VinSolutionsCrmIntegration",
    "VirtualTestDriveNew",
    "VirtualTestDriveUsed",
    "VolvoTechSpecsAndPackages",
    "VolvoTechSpecsAndPackagesCPO",
    "VolvoTechSpecsAndPackagesFleetNew",
    "VolvoTechSpecsAndPackagesFleetUsed",
    "VolvoTechSpecsAndPackagesNew",
    "Website.Departments",
    "Website.Departments.FINANCING",
    "Website.Departments.PARTS",
    "Website.Departments.RENTAL",
    "Website.Departments.SERVICE",
    "Website.Departments.Specials.FeaturedVehicles",
    "WebsiteReports.Advanced",
    "WebsiteReports.Dashboard.Performance",
    "WholesaleConfig",
    "WholesaleNewStockPhotos",
    "WholesaleNewVehicles",
    "WholesaleUsedStockPhotos",
    "WholesaleUsedVehicles",
    "WindowStickers"
  ],
  dealerCodeTypes: [
    "activation",
    "adp-sonic",
    "adw",
    "affiliate_promotions",
    "ais",
    "an-hyperion",
    "aoa",
    "aoa-ddc",
    "aoa-export",
    "aoaddc-cdc",
    "aoadistrict",
    "ar",
    "arca",
    "at-kbb",
    "au",
    "audicanada",
    "autocheck",
    "autonation",
    "auxiliary_options",
    "avis",
    "bmw",
    "bmw-export",
    "bmw_cpo",
    "bmw_cpo_tier2",
    "bmw_location",
    "bmw_region",
    "boa",
    "cci",
    "cci-ddc",
    "cllc",
    "cllc-ddc",
    "cllcbc",
    "cllcdistrict",
    "cllcpr",
    "clldaachrysler",
    "clldaadodge",
    "clldaajeep",
    "contact-at-once",
    "cvi_ddc_account_mapping",
    "dealer-socket",
    "dealertrack-post",
    "dmi",
    "driverside",
    "dt-dr-profile",
    "dtdms",
    "echoparkmarketid",
    "echoparkstoreid",
    "elead",
    "excluded_jeep_accounts",
    "fca-export",
    "fca_ca-export",
    "fca_vin_incentives",
    "fcamx",
    "fd",
    "fdca",
    "fdregion",
    "fiat",
    "fiat-ddc",
    "fiat-temp",
    "fiatca",
    "fiatpr",
    "flowautomotive",
    "fmc",
    "fmc-ddc",
    "ford-model-e",
    "fordregion",
    "gcb-mx",
    "genesis",
    "genesis_adi",
    "genesis_district",
    "genesis_region",
    "genesisdwcp",
    "gm",
    "gm-acc-ca",
    "gm-backlink-ca",
    "gm-carbravo",
    "gm-chipered-ca",
    "gm-dealer-ca",
    "gm-export",
    "gm-homenet",
    "gmca",
    "gmcabac",
    "gsm",
    "gst",
    "hertz",
    "hertzrouteone",
    "hertzrouteonefinance",
    "honda",
    "hondaadvdealer",
    "hondaoem",
    "hooklogic",
    "hyundai",
    "hyundai_adi",
    "hyundai_district",
    "hyundai_dma_cd",
    "hyundai_region",
    "hyundaictb",
    "hyundaidwcp",
    "jag",
    "jag-cpo",
    "jag-export",
    "jeep",
    "kia",
    "kia-reporting",
    "kia_inventory_export",
    "kiadmg",
    "kiadmggroup",
    "langley",
    "lender",
    "lexus",
    "lexus-export",
    "lexus-geo-key",
    "lexus-lda",
    "lhm",
    "lithia",
    "lr",
    "lr-export",
    "maserati",
    "mazda",
    "mazda-export",
    "mbz",
    "mercedes-export",
    "mini",
    "mini-export",
    "mitsubishi",
    "mitsubishi-export",
    "mitsuud",
    "mmd",
    "modernautomotive",
    "nci",
    "nissanleads",
    "nissanoem",
    "nissanservice",
    "nna",
    "offerlogix",
    "openlane",
    "ove",
    "penairfcu",
    "porsche",
    "ram",
    "rmau",
    "route-one",
    "ryantech-sonic",
    "saab",
    "saab-ddc",
    "scion",
    "scion_region",
    "sdis_lexus",
    "sdis_toyota",
    "simsmarketid",
    "simsstoreid",
    "sne",
    "snedistrict",
    "sneregion",
    "soa",
    "soa-ddc",
    "soa-mtl",
    "soadistrict",
    "soaregion",
    "soazone",
    "sonic",
    "sonic-callsource",
    "subaru-export",
    "suburban",
    "suzuki",
    "tc",
    "tcre-agent",
    "tcre-broker",
    "tcshortcode",
    "toyota",
    "toyota-export",
    "toyota_bat",
    "toyota_pooling",
    "toyota_region",
    "toyota_smartpath",
    "toyota_tcom",
    "toyota_tda",
    "trademotion",
    "unique_svoc_to_sa",
    "vinsolutions-ddc",
    "volvo",
    "volvo-ddc",
    "volvo-partner-id",
    "volvo_cbv_exclusion",
    "volvo_cle_vinless",
    "vw",
    "vw-daa",
    "vw-export",
    "w2w"
  ],
  franchises: [
    "Acura",
    "Alfa Romeo",
    "Aston Martin",
    "Audi",
    "BMW",
    "Bentley",
    "Bugatti",
    "Buick",
    "CADILLAC",
    "Chevrolet",
    "Chrysler",
    "Collision",
    "Daewoo",
    "Dodge",
    "FIAT",
    "Ferrari",
    "Fisker",
    "Ford",
    "GMC",
    "GTO",
    "Genesis",
    "Geo",
    "Honda",
    "Hummer",
    "Hyundai",
    "INFINITI",
    "Independent",
    "Isuzu",
    "Jaguar",
    "Jeep",
    "Karma",
    "Kia",
    "Lamborghini",
    "Land Rover",
    "Lexus",
    "Lincoln",
    "Lotus",
    "MINI",
    "Maserati",
    "Maybach",
    "Mazda",
    "McLaren",
    "Mercedes-Benz",
    "Mercury",
    "Mitsubishi",
    "Morgan",
    "Nissan",
    "Oldsmobile",
    "Peugeot",
    "Plymouth",
    "Pontiac",
    "Porsche",
    "Preowned",
    "Ram",
    "Renault",
    "Rolls-Royce",
    "SEAT",
    "Saab",
    "Saleen",
    "Saturn",
    "Scion",
    "Smart",
    "Spyker",
    "Subaru",
    "Suzuki",
    "Tesla",
    "Toyota",
    "Volkswagen",
    "Volvo"
  ]
};

export const lambdaTimeoutError = "LAMBDA_TIMEOUT_ERROR";

export const lambdaError = "LAMBDA_ERROR";
